<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2><em class="i">Thanks</em></h2>
<p><br/></p>
<p class="first"><span class="initial-cap char-style-override-2">E</span>ven though there may be one person pushing the pen on a project like this, it is nonetheless the product of a community of friends, too many to count.</p>
<p class="body">I would like to thank Aaron Gale for his book <em class="i">Redefining the Ancient Borders</em> and J. Andrew Overman for his <em class="i">Matthew’s Gospel and Formative Judaism</em>. Both of these works provided key backgrounds for the approach to Matthew as a scribal work that was initially focused on the synagogue community of Galilee. I also owe much to Stanley Hauerwas’s commentary on Matthew for the power of his images and the beauty of his language.</p>
<p class="body">When I first proposed that Matthew is the Gospel of identity, I shared the idea with three brothers who gave me deep encouragement to follow that line of thought: my new friends Michael Wilkins and Craig Keener, and George Guthrie, a very old and good friend and brother. They are all top-notch servants and scholars.</p>
<p class="body">The Wednesday night Bible study at Christ Community helped test many of these ideas. Thank you all for your faithfulness, week after week.</p>
<p class="body">In the final week of writing, Mark and Stephen at Sandy Cove Retreat Center provided me a place and some space to finish the rough draft. Thanks, brothers.</p>
<p class="body">Without the encouragement and support of InterVarsity Press, you would not be holding this book in your hands. Thanks to the entire team, especially Bob Fryling, Jeff Crosby and Al Hsu. Cindy Kiple has provided the rich designs for the covers.</p>
<p class="body">The team at Harvest Productions in Kansas City makes all of this possible, including concerts and Biblical Imagination Conferences. Thanks, Ron Davis, Holly Benyousky, Susan Surman, Whitney Smith and Shelby Turner.</p>
<p class="body">Thanks especially to my best friend, Scott Roley, for listening to my endless wanderings on the various ideas in this book and for giving me the space to talk through even the stupid ideas.</p>
<p class="body">Finally, blessings to my family, to my wife, Susan, and to our kids, Kate, Will, Maggie and Nate, for putting up with so much time away, not just for the writing of books, but for all of it, for so many years.</p>
<p class="body">Please receive this book from all of us as a gift to the church.</p>
<p class="body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Thanks.vue?5730d0bc